import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = {
  class: "part"
};
const _hoisted_3 = {
  class: "school-name"
};
const _hoisted_4 = {
  class: "part"
};
const _hoisted_5 = {
  class: "name head-user"
};
const _hoisted_6 = {
  class: "link-menu"
};
const _hoisted_7 = {
  class: "draw-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ArrowDown = _resolveComponent("ArrowDown");
  const _component_el_icon = _resolveComponent("el-icon");
  return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createElementVNode("div", {
    class: "hear-box",
    style: _normalizeStyle({
      height: $setup.heightCss + 'px'
    })
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "logo",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.goHomePage && $setup.goHomePage(...args))
  }), _createElementVNode("p", _hoisted_3, _toDisplayString($setup.userInfo.schoolName), 1)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: _normalizeClass($setup.route.meta.type == 'examlist' ? 'nav ac' : 'nav'),
    onClick: _cache[1] || (_cache[1] = $event => $setup.route.meta.trial ? $setup.router.push('/trial/examlist') : $setup.router.push('/examlist'))
  }, " 我的考试 ", 2), _createElementVNode("div", {
    class: _normalizeClass($setup.route.meta.type == 'reports' ? 'nav ac' : 'nav'),
    onClick: _cache[2] || (_cache[2] = $event => $setup.route.meta.trial ? $setup.router.push('/trial/reports') : $setup.router.push('/reports'))
  }, " 我的报告 ", 2), $setup.userInfo.name ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "user head-user",
    id: "head_user",
    onClick: _cache[3] || (_cache[3] = $event => $setup.route.meta.trial ? '' : $setup.linkMenu())
  }, [_createElementVNode("p", _hoisted_5, _toDisplayString($setup.userInfo.name), 1), _createVNode(_component_el_icon, {
    class: "head-user",
    style: {
      "margin-left": "5px",
      "cursor": "pointer"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_ArrowDown, {
      class: "head-user"
    })]),
    _: 1
  })])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "logout",
    onClick: _cache[4] || (_cache[4] = (...args) => $setup.logout && $setup.logout(...args))
  }, "退出")])])], 4), [[_vShow, $setup.showHeader]]), _withDirectives(_createElementVNode("div", _hoisted_6, [_createElementVNode("ul", null, [_createElementVNode("li", {
    onClick: _cache[5] || (_cache[5] = $event => $setup.router.push('/userinfo'))
  }, "我的信息"), _createElementVNode("li", {
    onClick: _cache[6] || (_cache[6] = $event => $setup.router.push('/feedback'))
  }, "意见反馈")])], 512), [[_vShow, $setup.linkMenuShow]]), _withDirectives(_createElementVNode("div", _hoisted_7, [_createElementVNode("span", {
    onClick: _cache[7] || (_cache[7] = $event => $setup.heightCss ? $setup.heightCss = 0 : $setup.heightCss = 60)
  }, _toDisplayString($setup.heightCss ? "收起导航" : "展开导航"), 1)], 512), [[_vShow, $setup.route && $setup.route.meta.type == 'exam' && !$setup.route.query.appKey]])], 64);
}